import React, { Component } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import onClickOutside from 'react-onclickoutside';

import DateRangePicker from './components/DateRangePicker';
import { dateRangeToDisplay, maxDate } from './configs';

class DateRangeDropdown extends Component {
  static defaultProps = {
    menuAlign: 'end',
    dataStartDate: null,
    limitedPeriodText: '',
  };

  state = {
    open: false,
  }

  handleToggleOpen = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  handleClick = () => !this.props.disabled && this.handleToggleOpen();

  handleClickOutside = () => {
    this.setState({ open: false });
  }

  handleSubmit = ({ period, date_from, date_to }) => {
    this.props.onChange({
      period,
      period_from_date: date_from,
      period_to_date: date_to,
    });
    this.handleToggleOpen();
  }

  render() {
    const { open } = this.state;
    const {
      dateTo,
      dateFrom,
      maxPeriod,
      currentPeriod,
      maxShowedPeriod,
      maxSelectablePeriod,
      maxDateTo,
      disabled,
      menuAlign,
      dataStartDate,
      limitedPeriodText,
    } = this.props;

    const maxDateObj = maxDate(maxDateTo);

    return (
      <div className={cx('dropdown date-range-dropdown', { open })}>
        <button
          type="button"
          className="btn btn-dropdown no-caret dropdown-unified-calendar"
          disabled={disabled}
          onClick={this.handleClick}
        >
          {dateRangeToDisplay(currentPeriod, dateFrom, dateTo, maxDateObj)}
        </button>
        {open && (
          <div
            className={cx('dropdown-menu date-range-menu',
              menuAlign === 'end' && 'dropdown-menu-right',
              menuAlign === 'center' && 'dropdown-menu-center')}
          >
            <DateRangePicker
              maxPeriod={maxPeriod}
              maxDate={maxDateObj}
              currentPeriod={currentPeriod}
              maxShowedPeriod={maxShowedPeriod}
              maxSelectablePeriod={maxSelectablePeriod}
              dateTo={dateTo}
              dateFrom={dateFrom}
              dataStartDate={dataStartDate}
              limitedPeriodText={limitedPeriodText}
              onSubmit={this.handleSubmit}
              onCancel={this.handleToggleOpen}
            />
          </div>
        )}
      </div>
    );
  }
}

DateRangeDropdown.propTypes = {
  onChange: T.func.isRequired,
  maxPeriod: T.number.isRequired,
  currentPeriod: T.number.isRequired,
  dateTo: T.string,
  dateFrom: T.string,
  maxShowedPeriod: T.number,
  maxSelectablePeriod: T.number,
  maxDateTo: T.instanceOf(Date),
  disabled: T.bool,
  menuAlign: T.oneOf(['start', 'center', 'end']),
  dataStartDate: T.string,
  limitedPeriodText: T.string,
};

export default onClickOutside(DateRangeDropdown);
